import { Loader } from "@vibe/core";

interface PageLoaderProps {
  screenHeight?: boolean;
  minHeight?: number;
}

const PageLoader = ({ screenHeight = true, minHeight }: PageLoaderProps) => {
  return (
    <div
      className={`flex items-center justify-center w-full ${
        screenHeight ? "h-screen" : minHeight ? "" : "h-auto"
      }`}
      // minHeight must be inline: a template-built Tailwind class like
      // `min-h-[${minHeight}px]` is never emitted by the JIT compiler (it only scans
      // for complete literal class strings), so the wrapper would collapse to zero
      // height and the loader would pin to the top instead of centering.
      style={!screenHeight && minHeight ? { minHeight } : undefined}
    >
      <Loader color="primary" size="medium" />
    </div>
  );
};

export default PageLoader;
